import { useFlags as useLDFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";
import { defaultFlags } from "../launchDarkly/defaultFlags";

const inDevelopment =
  process.env.NODE_ENV === "development" ||
  window.location.hostname === "scopestack.test";

const useDevEnvironmentFlags = () => {
  const [devFlags] = useState({
    ...defaultFlags,
  });
  return devFlags;
};

const getProperHook = () => {
  if (inDevelopment) {
    return useDevEnvironmentFlags;
  }
  return useLDFlags;
};

const useFlags = getProperHook();

export default useFlags;
